'use client';

import { Grid, GridColumn, Typography, Button, Box } from '@kohler-dsm-library/kohler-core';
import { useRef, useState } from 'react';
import { useHotspots } from './hooks/useHotspots';
import HotspotImage from './HotspotImage';
import FeatureCarousel from './FeatureCarousel';
import './styles/featuredProductCollection.css';

const props = {
  variant: 'secondary',
  size: 'large',
};

const FeaturedProductCollectionClient = ({ data, hotspots, cards }) => {
  const { eyebrow, title, description, ctaLabel, ctaLink, fileReference } = data;
  const imageRef = useRef(null);

  const normalizedHotspots = useHotspots(hotspots);

  const [activeId, setActiveId] = useState('A');

  const [hoveredId, setHoveredId] = useState(null);

  return (
    <Grid className="fpc">
      {/* LEFT CONTENT */}
      <GridColumn span={6} spanSmall={12} className="fpc-content">
        <Box className="fpc-content-label">
          {eyebrow && (
            <Typography size="label-medium-m" component="p" className="eyebrow">
              {eyebrow}
            </Typography>
          )}
          {title && (
            <Typography size="h3" component="h3" className="title">
              {title}
            </Typography>
          )}
          {description && (
            <Typography size="label-medium-m" component="p" className="description">
              {description}
            </Typography>
          )}
        </Box>
        {ctaLabel && ctaLink && (
          <div className="fpc-cta-container">
            <Button className="fpc-cta" {...props}>
              {ctaLabel}
            </Button>
          </div>
        )}
      </GridColumn>

      {/* IMAGE */}
      <GridColumn span={6} spanSmall={12} className="fpc-image">
        {fileReference && (
          <HotspotImage
            image={fileReference}
            hotspots={normalizedHotspots}
            hoveredId={hoveredId}
            activeId={activeId}
            onSelect={setActiveId}
            onHover={setHoveredId}
            imageRef={imageRef}
          />
        )}
      </GridColumn>

      {/* CARDS */}
      <GridColumn span={12} className="fpc-carouselWrapper">
        {cards && (
          <FeatureCarousel
            cards={cards}
            activeId={activeId}
            hoveredId={hoveredId}
            onSelect={setActiveId}
            onHover={setHoveredId}
          />
        )}
      </GridColumn>
    </Grid>
  );
};

export default FeaturedProductCollectionClient;
